import type { ReactNode } from "react";

import { toast } from "@heroui/react";

/** The one toast system. `<Toast.Provider />` is mounted once in `provider.tsx`. */
export const notify = {
  success: (title: ReactNode, description?: ReactNode) =>
    toast.success(title, { description }),
  error: (title: ReactNode, description?: ReactNode) =>
    toast.danger(title, { description }),
  info: (title: ReactNode, description?: ReactNode) =>
    toast.info(title, { description }),
  warning: (title: ReactNode, description?: ReactNode) =>
    toast.warning(title, { description }),
};
